import { IconButton, ListItem } from '@mui/material';
import type { CSSProperties, FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { Link, useResolvedPath } from 'react-router-dom';

interface SideMenuLinkItemProps {
  to?: string;
  icon?: ReactNode;
  style?: CSSProperties;
  disabled?: boolean;
  onClick?: () => void;
}

const SideMenuLinkItem: FC<SideMenuLinkItemProps> = ({ to, icon, style, disabled, onClick, ...props }) => {
  const path = useResolvedPath(to ?? '');

  const isActive = location.pathname.includes(path.pathname);
  const component = to ? Link : 'button';

  const onClickProp = useMemo(() => {
    if (to) return undefined;
    if (onClick) return onClick;

    return undefined;
  }, [to, onClick]);

  return (
    <ListItem style={{ ...style }} {...props} sx={{ p: 0 }}>
      <IconButton
        component={component}
        to={to}
        replace
        sx={(t) => ({
          display: 'flex',
          gap: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          p: 1,
          borderRadius: t.borderRadius.md,
          color: isActive ? t.palette.primary.main : t.palette.text.secondary,
          backgroundColor: isActive ? 'rgba(41, 121, 255, 0.08)' : 'transparent',
          position: 'relative',
          transition: 'none',

          '& svg': {
            fill: isActive ? t.palette.primary.main : t.palette.text.secondary,
          },

          '&:hover': {
            color: t.palette.primary.main,
            backgroundColor: isActive ? 'rgba(41, 121, 255, 0.08)' : 'transparent',
          },
          '&:hover .MuiSvgIcon-root': {
            color: t.palette.primary.main,
          },
          '&[disabled]': {
            color: t.palette.text.disabled,
          },
        })}
        onClick={onClickProp}
        disabled={disabled}
      >
        {icon}
      </IconButton>
    </ListItem>
  );
};

export default SideMenuLinkItem;
